// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import VueSession from 'vue-session'

import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from 'vuestic-ui/src/services/ColorThemePlugin'
import store from '../store/index'
import router from '../router/index'
import VuesticPlugin from 'vuestic-ui/src/components/vuestic-plugin'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
// import VeeValidate from 'vee-validate'
import VeeValidate, { Validator, ValidationObserver, ValidationProvider } from 'vee-validate'
import es from 'vee-validate/dist/locale/es'
import * as rules from 'vee-validate/dist/rules.esm'
import { mapActions } from 'vuex'
import '../metrics'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VModal from 'vue-js-modal'
import VueListPicker from 'vue-list-picker'
import VuejsDialog from 'vuejs-dialog'
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
//Estilos globales
import '@/assets/styles/formsGlobal.css'
import VueFormWizard from 'vue-form-wizard'
import '@/assets/global.css'

Vue.use(VueFormWizard)
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VuejsDialog)
Vue.use(VuejsDialogMixin)
Vue.use(VModal, { dialog: true })
Vue.use(VueSession)

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Object.keys(rules).forEach(rule => { Validator.extend(rule, rules[rule]) })

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)
Vue.use(VueListPicker)

Vue.use(Loading,
  {
    color: '#222',
    backgroundColor: '#fff',
    loader: 'dots',
    opacity: 0.6,
    width: 100,
    height: 100,
  })
Vue.use(VeeValidate, { classes: true, classNames: { valid: 'is-valid', invalid: 'is-invalid' } })
Validator.localize('es', es)

Vue.use(ColorThemePlugin,
  {
    themes: {
      primary: '#222',
      secondary: '#fff',
    },
  })

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created: function () { this.callIberoWS() },
  methods: { ...mapActions(['callIberoWS']) },
})
